var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandSetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 19C14.95 19 19 14.95 19 10C19 5.05 14.95 1 10 1C5.05 1 1 5.05 1 10C1 14.95 5.05 19 10 19Z",
    fill: "white",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 34846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3001 6.19249L7.00758 10.485C6.84415 10.6485 6.68073 10.9699 6.64805 11.2041L6.41381 12.8438C6.32665 13.4375 6.7461 13.8515 7.33987 13.7698L8.97953 13.5356C9.20832 13.5029 9.52972 13.3395 9.69859 13.176L13.9911 8.8835C14.732 8.14266 15.0806 7.28197 13.9911 6.19249C12.9017 5.10301 12.041 5.45164 11.3001 6.19249Z",
    stroke: "#0008C3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6836 6.80859C11.0486 8.11052 12.0672 9.12918 13.3746 9.49961",
    stroke: "#0008C3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSetIcon);
export default __webpack_public_path__ + "static/media/hand_set_icon.a54ea97c9fbcf1353cbcef14743e0301.svg";
export { ForwardRef as ReactComponent };